module.exports = "<ng-template>\n  <ng-content></ng-content>\n</ng-template>"